import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Stack,
    FormControlLabel,
    FormGroup,
    Checkbox
} from '@mui/material'
import React, { useState, useEffect } from 'react'
import { createEmployeeLeave, updateEmployeeLeave } from '../../../../services/LeaveService'

const LeaveEmployeeUpdateModal = ({ open, onClose, onUpdateSuccess, data }) => {
    const [errors, setErrors] = useState({})
    const [responseMessage, setResponseMessage] = useState('')
    const [showResponseDialog, setShowResponseDialog] = useState(false)
    const [loading, setLoading] = useState(false)

    const [newLeave, setNewLeave] = useState({
        employeeId: null,
        vacationLeave: 0,
        sickLeave: 0,
        maternityLeave: false,
        paternityLeave: false
    })

    useEffect(() => {
        if (data) {
            setNewLeave({
                id: data.id,
                employeeId: data.employeeId || '',
                vacationLeave: data.vacationLeave || 0,
                sickLeave: data.sickLeave || 0,
                maternityLeave: data.maternityLeave || false,
                paternityLeave: data.paternityLeave || false
            })
        }
    }, [data])

    const validateFields = () => {
        const newErrors = {}
        const requiredFields = ['employeeId', 'vacationLeave', 'sickLeave']

        requiredFields.forEach((field) => {
            if (newLeave[field] === null || newLeave[field] === '') {
                newErrors[field] = 'This field is required'
            }
        })

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleRegisterInputChange = (e) => {
        const { name, value, type, checked } = e.target
        setNewLeave((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }))
    }

    const handleFormSubmit = async (event) => {
        event.preventDefault()

        if (loading) return
        setLoading(true)

        if (validateFields()) {
            try {
                const result = await updateEmployeeLeave(newLeave)
                setResponseMessage(result.error || result.message)
                setShowResponseDialog(true)

                if (!result.error) {
                    onUpdateSuccess()
                    setNewLeave({
                        employeeId: null,
                        vacationLeave: 0,
                        sickLeave: 0,
                        maternityLeave: false,
                        paternityLeave: false,
                        remarks: ''
                    })
                }
            } catch (error) {
                setResponseMessage('An error occurred while processing the leave request.')
                setShowResponseDialog(true)
            } finally {
                setLoading(false)
                onClose()
            }
        } else {
            setLoading(false)
        }
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>Update Employee Leave</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleFormSubmit}>
                        <Stack spacing={2} className="m-2">
                            {/* Display Full Name */}
                            <TextField
                                margin="normal"
                                label="Employee Name"
                                fullWidth
                                value={data?.fullName || ''}
                                disabled
                            />

                            <TextField
                                margin="normal"
                                name="vacationLeave"
                                label="Vacation Leave"
                                fullWidth
                                type="number"
                                variant="outlined"
                                value={newLeave.vacationLeave}
                                onChange={handleRegisterInputChange}
                                error={Boolean(errors.vacationLeave)}
                                helperText={errors.vacationLeave}
                            />

                            <TextField
                                margin="normal"
                                name="sickLeave"
                                label="Sick / Emergency Leave"
                                fullWidth
                                type="number"
                                variant="outlined"
                                value={newLeave.sickLeave}
                                onChange={handleRegisterInputChange}
                                error={Boolean(errors.sickLeave)}
                                helperText={errors.sickLeave}
                            />

                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={newLeave.maternityLeave}
                                            onChange={handleRegisterInputChange}
                                            name="maternityLeave"
                                        />
                                    }
                                    label="Maternity Leave"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={newLeave.paternityLeave}
                                            onChange={handleRegisterInputChange}
                                            name="paternityLeave"
                                        />
                                    }
                                    label="Paternity Leave"
                                />
                            </FormGroup>

                            <TextField
                                margin="normal"
                                name="remarks"
                                label="Remarks"
                                fullWidth
                                variant="outlined"
                                multiline
                                rows={4}
                                value={newLeave.remarks}
                                onChange={handleRegisterInputChange}
                            />
                        </Stack>

                        <DialogActions style={{ marginTop: '16px' }}>
                            <Button onClick={onClose} color="secondary">
                                Close
                            </Button>
                            <Button type="submit" color="primary" variant="contained" disabled={loading}>
                                {loading ? 'Updating...' : 'Update'}
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>

            {/* Response Dialog */}
            <Dialog open={showResponseDialog} onClose={() => setShowResponseDialog(false)}>
                <DialogTitle>Response</DialogTitle>
                <DialogContent>
                    <p>{responseMessage}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowResponseDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default LeaveEmployeeUpdateModal
